import React from 'react'
import Header from './component/layout/Header'
import Footer from './component/layout/Footer'
import ResetPass from "./component/ResetPass.jsx"
const PasswordReset = () => {
  return (
   <>
   <Header/>
   <ResetPass/>
   <Footer/>
   </>
  )
}

export default PasswordReset
